<template>
  <div class="head-title">
    <div class="left-logo">
      <div class="img">
        <!-- <div class="yuan"></div> -->
        <img style="width: 100px;" src="../../../pc/image/log.png" alt="">

      </div>
      <!-- <div class="text">WDP</div> -->
    </div>
    <div class="right-head-img">
      <div class="img-title">

      </div>
      <div class="btn-wai">

        <!-- <div class="btn"></div> -->
      </div>
      <div class="xia">
        <img src="../../../pc/image/t4.png" class="zuo" alt="" />

              <div class="xia-la">
                <div class="list" @click="open('https://t.me/wdpapperc20portal')">
                  <img src="../../../pc/image/t5 (2).png" alt="">
                  <div class="text">Telegram</div>
                </div>
                <div class="list" @click="open('https://twitter.com/WDPAIGAMING')">
                  <img src="../../../pc/image/t5 (1).png" alt="">
                  <div class="text">Twitter</div>
                </div>
                <div class="list"  @click="open('https://docs.wdp.app')">
                  <img src="../../../pc/image/t5 (3).png" alt="">
                  <div class="text">whitepaper</div>
                </div>
              </div>
            </div>

    </div>
  </div>
</template>

<script>
export default {
  methods:{
    open(url){
      window.location.href=url
    }
  },
};
</script>

<style lang="less" scoped>
      .xia {
                    margin-right: 0;
                    position: relative;
                    display: flex;
                    align-items: center;

                    >img {
                        margin-left: 2px;
                        width: 16px;
                        height: 16px;
                        // transform: rotate(-90deg);
                        // transition: all 0.5s;
                    }

                    .xia-la {
                        // display: none;
                        height: 0;
                        overflow: hidden;
                        flex-direction: column;
                        background: rgba(65, 65, 65, 0.65);
                        border-radius: 12px;
                        position: absolute;
                        top: 100%;
                        left: -112px;
                        transition: all 0.5s;
                        box-sizing: border-box;
                        z-index: 9;

                        >div {
                            margin-top: 15px;
                        }

                        >div:first-child {
                            margin-top: 0;
                        }

                        .list {
                            display: flex;
                            align-items: center;
                            cursor: pointer;

                            img {
                                width: 20px;
                                height: 20px;
                                margin-right: 8px;
                            }

                            .text {
                                font-family: Flynn mono VF;
                                font-size: 12px;
                                font-weight: normal;
                                line-height: 16px;
                                color: #D1D1D1;
                            }
                        }

                        .list:hover .text {
                            cursor: pointer;
                            color: #0099f7;
                            text-decoration: dashed;
                        }
                    }
                }

                .xia:hover {
                    >img {
                        transform: rotate(0deg);
                    }

                    .xia-la {
                        height: 134px;
                        padding: 10px;
                        display: block;
                    }
                }
        .yuan{
            width: 28px;
height: 28px;
background: linear-gradient(127deg, #5780FF 0%, #1434E1 100%);
opacity: 1;
border: 2px solid #082F64;
border-radius: 50%;

        }
.head-title {
  padding-top: 5px;
  height: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left-logo {
    display: flex;

    .img {
      width: 31px;
      height: 35px;
      margin-right: 10px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .text {
      font-family: Flynn mono VF;
      font-size: 27px;
      font-weight: normal;
      line-height: 27px;
      letter-spacing: 0em;
      color: #fff;
 
    }
  }

  .right-head-img {
    width: 129px;
    height: 21px;
    display: flex;
    justify-content: space-between;

    .img-title {
      display: flex;
      align-items: center;

      .title {
        width: 20px;
        height: 20px;
        margin-right: 6px;
      }

      .zuo {
        width: 9px;
        height: 5px;
      }
    }

  
  }
}
</style>